/** Running cumulative sum: [a, b, c] -> [a, a+b, a+b+c]. */
export function cumulativeSum(values: number[]): number[] {
  let running = 0;
  return values.map((v) => (running += v));
}
